module.exports = __webpack_public_path__ + "static/img/5.a28e083.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos-en/5.jpg
// module id = GFzQ
// module chunks = 0